export default "__VITE_ASSET__CDOuJY98__"